import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { ScoreContext } from './score.context';
import { IBaseScoreSection, IBaseVariableSection } from 'src/services/api/api-client';

export const ScoreContextProvider: FC<
  PropsWithChildren<{
    initialScoreSections: IBaseScoreSection[];
    initialVariables: IBaseVariableSection[];
  }>
> = (props) => {
  const [scoreSections, setScoreSections] = useState<IBaseScoreSection[] | undefined>(props.initialScoreSections);
  const [variables, setVariables] = useState<IBaseVariableSection[] | undefined>(props.initialVariables);

  useEffect(() => {
    setScoreSections(props.initialScoreSections);
    setVariables(props.initialVariables);
  }, [props]);

  return (
    <ScoreContext.Provider
      value={{
        scoreSections,
        setScoreSections,
        variables,
        setVariables,
      }}
    >
      {props.children}
    </ScoreContext.Provider>
  );
};
